
<app-header></app-header>

<app-presidents></app-presidents>
<app-right-side></app-right-side>

<div class="container" [dir]="direction">
    <div class="row">
        <div class="col col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="clients-grid">

                <ul class="cat-list-bg-style align-center sorting-menu">
                    <li class="cat-list__item" data-filter="*">
                        <a routerLink="/executive-committee" class=""> 
                            <strong>{{'honorable-committee.executive_committee' | translate}}</strong> </a>
                    </li>
                    <li class="cat-list__item active" data-filter=".politics">
                        <a routerLink="/honorable-committee" class="">
                        <strong> {{'honorable-committee.honorable_committee' | translate}} </strong></a>
                    </li>
                    <li class="cat-list__item" data-filter=".natural">
                        <a routerLink="/iffhs-members" class="">
                            <strong>{{'honorable-committee.iffhs_member' | translate}} </strong></a></li>
                    <li class="cat-list__item" data-filter=".worlds">
                        <a routerLink="/president-consultant" class="">
                            <strong> {{'honorable-committee.president_consultant' | translate}} </strong></a>
                    </li>
                    <li class="cat-list__item" data-filter=".animals">
                        <a routerLink="/president-assistants" class="">
                            <strong> {{'honorable-committee.president_assistant' | translate}}</strong></a>
                    </li>
                    
                    <li class="cat-list__item" data-filter=".animals">
                        <a routerLink="/ranking" class="">
                            <strong> {{'honorable-committee.ranking' | translate}} </strong> </a>
                    </li>
                    
                   
                </ul>

                <div class="row sorting-container" id="clients-grid-1" data-layout="masonry">

                    <div class="col col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 sorting-item ecommerce natural">
                        <div class="ui-block">

                            <article class="hentry post has-post-thumbnail">

                                <div class="post-thumb">

                                    <a href="javascript:void(0);" (click)="onClick(images[0])" id="edward" style="position: absolute;margin-top: 180px; margin-left: 110px;"><span
											style="opacity: 0;font-size: 30px;">Carlos<br><BR><BR></span></a>
                                    <a href="javascript:void(0);" (click)="onClick(images[1])" id="carlos" style="position: absolute;margin-top:180px; margin-left:340px;"><span
											style="opacity: 0;font-size: 30px;">Edward<br><BR><BR></span></a>

                                    <img src="../../../assets/img/honorable.jpg" alt="photo" style="width: 100%; height: 380px; margin: 0px auto;">
                                </div>



                            </article>
                        </div>
                    </div>

                    
                </div>

            </div>
        </div>
        <!-- <app-iffhs-news></app-iffhs-news> -->
    </div>
</div>